const root = 'online-top-area-root';
const rootEl = document.getElementById(root);

if (!rootEl) {
  throw new Error(`Element with selector "#${root}" is required to run this SPA`);
}

const init = async (): Promise<void> => {
  const appRender = await import(/* webpackChunkName: "app" */ './AppRender');

  await appRender.render();
};

init().catch((error) => {
  throw error;
});

export {}; // needed so the TS treats this file as a module
